var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoddashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-pod"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pod",
    clipPath: "url(#clip-pod)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pod_upload_red",
    transform: "translate(-1.371 -3.457)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 0.429,
    cy: 0.429,
    r: 0.429,
    transform: "translate(3.942 5.172)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 0.429,
    cy: 0.429,
    r: 0.429,
    transform: "translate(5.656 5.172)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 0.429,
    cy: 0.429,
    r: 0.429,
    transform: "translate(7.37 5.172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M23.66,14.4V5.506a2.05,2.05,0,0,0-2.05-2.049H3.42A2.049,2.049,0,0,0,1.371,5.506V18.554A2.048,2.048,0,0,0,3.42,20.6h13.3a4.656,4.656,0,0,0,3.933,2.143,4.714,4.714,0,0,0,3-8.348ZM3.42,4.315H21.609A1.192,1.192,0,0,1,22.8,5.507V6.888H2.228V5.506A1.191,1.191,0,0,1,3.42,4.315ZM2.228,18.554V7.744H22.8v6.1h-.05a4.717,4.717,0,0,0-6.809,4.192,3.381,3.381,0,0,0,0,.524,4.183,4.183,0,0,0,.352,1.191H3.436a1.189,1.189,0,0,1-1.208-1.174Zm18.43,3.335a3.818,3.818,0,0,1-3.429-2.118h0a3.5,3.5,0,0,1-.386-1.286,3.46,3.46,0,0,1-.042-.455,3.867,3.867,0,0,1,3.856-3.858,3.931,3.931,0,0,1,1.716.394c.146.086.291.164.436.259a3.858,3.858,0,0,1-2.144,7.064Z",
    transform: "translate(0)",
    fill: "#5964ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M18.7,13.93l-2.015,2.023a.424.424,0,1,0,.6.6l.987-.977v3.249a.429.429,0,0,0,.858,0V15.575l.984.977a.412.412,0,0,0,.583.019c.007-.006.012-.012.019-.019a.414.414,0,0,0,.02-.583c-.008-.006-.014-.012-.02-.017Z",
    transform: "translate(1.959 1.35)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(3.618 10.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M3.361,10.007a8.671,8.671,0,0,1,1.441-.1,2.265,2.265,0,0,1,1.441.377,1.381,1.381,0,0,1,.5,1.092A1.5,1.5,0,0,1,6.312,12.5a2.183,2.183,0,0,1-1.532.5,2.568,2.568,0,0,1-.364-.021v1.686H3.361Zm1.056,2.14a1.614,1.614,0,0,0,.357.027c.567,0,.917-.287.917-.77,0-.434-.3-.692-.832-.692a1.85,1.85,0,0,0-.44.042v1.393Z",
    transform: "translate(-3.361 -9.866)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M11.3,12.256a2.248,2.248,0,0,1-2.315,2.483,2.2,2.2,0,0,1-2.217-2.4A2.282,2.282,0,0,1,9.059,9.871,2.2,2.2,0,0,1,11.3,12.256Zm-3.406.063c0,.922.434,1.574,1.147,1.574s1.133-.685,1.133-1.6c0-.846-.405-1.574-1.14-1.574S7.892,11.4,7.892,12.32Z",
    transform: "translate(-2.922 -9.871)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M11.395,10.007a9.479,9.479,0,0,1,1.442-.1,3.032,3.032,0,0,1,1.929.5,2.085,2.085,0,0,1,.8,1.777,2.388,2.388,0,0,1-.783,1.908,3.378,3.378,0,0,1-2.175.608,9.045,9.045,0,0,1-1.21-.07Zm1.07,3.845a1.833,1.833,0,0,0,.371.023,1.462,1.462,0,0,0,1.594-1.652,1.352,1.352,0,0,0-1.482-1.5,2.272,2.272,0,0,0-.483.042Z",
    transform: "translate(-2.325 -9.866)",
    fill: "#212121"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoddashboard);
export default __webpack_public_path__ + "static/media/poddashboard.a3582daf26f25f30ad2bb7158a429090.svg";
export { ForwardRef as ReactComponent };